/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReplay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.293 1.293 8.586 5l3.707 3.707 1.414-1.414-1.279-1.28a7 7 0 1 1-7.424 7.228L5 13H3a9 9 0 1 0 9.406-8.991l1.301-1.302z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgReplay as Replay };
